module.exports = __webpack_public_path__ + "assets/img/guide-2.f3478523.png";